import { View3dGlobal, ThreeView, ModelInfo } from '..';
import { matUtils } from '../../base';
import { ObjectLoader } from './ObjectLoader';

export class StairLoader {

    /* loadStairs
     * 階段等の読込.
     */
    public loadAsync(): void {
        const stairList: ModelInfo[] = this.StairsList();
        Promise.all(stairList.map((modelinfo: ModelInfo) => {
            return new ObjectLoader().loadASync(modelinfo)
                                        .then((object) => {
                                            ThreeView.get().wcItemmgr.fittings.push(<THREE.Group>(object));
                                            matUtils.turnOffLights(<THREE.Group>(object));
                                            ThreeView.get().wcItemmgr.registObjects(<THREE.Group>(object));
                                            ThreeView.get().wcItemmgr.houseObjects.add(<THREE.Group>(object));
                                            ThreeView.get().wcItemmgr.houseData.push(<THREE.Object3D>(object));
                                            ThreeView.get().matmgr.applyObjectMaterial(<THREE.Group>(object), true);
                                        });
        }));
    }

    /* getStairsList
     * 読み込む階段のリストを作成.
     */
    private StairsList(): ModelInfo[] {
        return View3dGlobal.shared.staData.filter((item) => item.isValid()).map((item) => item.setupURL3D());
    }
}
